import { computed, ref } from 'vue';
import { defineStore } from 'pinia';

type ModalData = {
  id: string;
  active: boolean;
};

export const useModalStore = defineStore('modalStore', () => {
  const modals = ref(new Map<string, ModalData>());

  const setModalState = (id: string, modalState: boolean) => {
    addModal(id);
    if (modals.value.has(id)) {
      const currentModal = modals.value.get(id)!;
      modals.value.set(id, { ...currentModal, active: modalState });
    }
  };

  const addModal = (id: string, initialState: boolean = false) => {
    if (!modals.value.has(id)) {
      modals.value.set(id, { id, active: initialState });
    }
  };

  const removeModal = (id: string) => {
    modals.value.delete(id);
  };

  const openModal = (id: string) => {
    setModalState(id, true);
  };

  const closeModal = (id: string) => {
    setModalState(id, false);
  };

  // Changed from function to direct computed property
  const useModalState = (id: string) => {
    return computed(() => ({
      exists: modals.value.has(id),
      active: modals.value.get(id)?.active ?? false,
      data: modals.value.get(id),
    }));
  };

  return {
    modals,
    addModal,
    removeModal,
    openModal,
    closeModal,
    useModalState,
  };
});
